module.exports = __webpack_public_path__ + "static/media/dmtd2.feae9939.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dmtd2.jpg
// module id = 325
// module chunks = 0